import axios from 'axios';
// config

// ----------------------------------------------------------------------
const axiosInstance = 
// localStorage.getItem('accessToken') ? 
//   axios.create({
//     baseURL: 'https://api.siteprogress.ae/api',
//     headers: {
//       'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
//     }
//   }) : 
  axios.create({
    baseURL: 'https://api.siteprogress.ae/api'
  });


export const baseURL = `https://api.siteprogress.ae/api/`

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  profile: '/profile',
  addUser: '/admin/users',
  Addprojects: '/admin/projects',
  Projects: '/admin/projects',
  Projetsdetails: '/admin/project'
  ,
  updateUser: '/admin/users',
  auth: {
    me: '/api/auth/me',
    login: '/login',
    register: '/api/auth/register',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
};
